import { Navigate, useNavigate, useParams } from 'react-router-dom';
import BrandDetailsDialog from '../../BrandDetailsDialog';
import { editBrand } from '../../hooks/useBrands';
import { showToastError, showToastSuccess } from '../../components/ToastNotifications';
import { useLegacyAppSession } from '../../contexts/LegacyAppSessionContext';

export default function EditBrandContainer() {
  const navigate = useNavigate();
  const params = useParams();
  const { org } = useLegacyAppSession();
  const brandId = String(params.brandId || '');

  if (!brandId) {
    return <Navigate to="/brands" replace />;
  }

  return (
    <BrandDetailsDialog
      title="Edit Brand"
      brandId={brandId}
      currentOrg={org}
      onClose={() => navigate('/brands', { replace: true })}
      onSave={async (updated) => {
        try {
          await editBrand(updated);
          showToastSuccess('Brand successfully saved.');
          navigate('/brands', { replace: true });
        } catch (error) {
          showToastError('Brand could not be saved.');
          console.error(error);
        }
      }}
    />
  );
}
